import request from '@/plugins/request';

/**
 * 获取新闻资讯列表
 * @param {Object} params - 请求参数，如页码、类型等
 * @returns {Promise} - 返回Promise对象
 */
export function getNewsList(params) {
  return request({
    url: '/fronted/media/news',
    method: 'get',
    params
  });
}

/**
 * 获取新闻资讯列表（新端点）
 * @param {Object} params - 请求参数，如页码、类型等
 * @returns {Promise} - 返回Promise对象
 */
export function getNewsListNew(params) {
  return request({
    url: '/fronted/news/list',
    method: 'get',
    params
  });
}

/**
 * 获取新闻详情
 * @param {string|number} id - 新闻ID
 * @returns {Promise} - 返回Promise对象
 */
export function getNewsDetail(id) {
  return request({
    url: `/fronted/news/${id}`,
    method: 'get'
  });
}

/**
 * 获取媒体资源列表（如视频、图片等）
 * @param {Object} params - 请求参数，如页码、资源类型等
 * @returns {Promise} - 返回Promise对象
 */
export function getMediaResources(params) {
  return request({
    url: '/fronted/media/resources',
    method: 'get',
    params
  });
}

/**
 * 获取展会信息列表
 * @param {Object} params - 请求参数，如页码等
 * @returns {Promise} - 返回Promise对象
 */
export function getExhibitionList(params) {
  return request({
    url: '/fronted/media/exhibitions',
    method: 'get',
    params
  });
}

/**
 * 获取展会详情
 * @param {string|number} id - 展会ID
 * @returns {Promise} - 返回Promise对象
 */
export function getExhibitionDetail(id) {
  return request({
    url: `/fronted/media/exhibitions/${id}`,
    method: 'get'
  });
}
